import React, { useState, useEffect } from "react";
import {
  NavLink,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import PropTypes from "prop-types";
import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  TextField,
  makeStyles,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { textFormat } from "utils/Utils";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../components/UpdateUi/CustomeSelect";
import brandTheme from "brandTheme/Theme";
import SchemeCharge from "./SchemeCharges";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
import MSelect from "react-select";
import makeAnimated from "react-select/animated";
import CustomTextSelect from "components/UpdateUi/CustomeTextSelect";
import FindProductType from "helper/FindProductType";
import DealShareModal from "./DealShareModal/DealShareModal";
import { handleOnlyNumber } from "utils/Utils";
import { loanTypeList } from "assets/properties/properties";
import { CustomerTypeList } from "assets/properties/properties";
import { getNewCustomerValue } from "assets/properties/properties";
import { getCustomerType } from "assets/properties/properties";
import { tenureTypeList } from "assets/properties/properties";
import { durationUnits } from "assets/properties/properties";
const style = () => ({
  textField: {
    display: "block",
    width: "100%",
    borderColor: brandTheme.black,
    "& .Mui-disabled": {
      color: brandTheme.fieldColor,
    },
    "& .MuiInputBase-input": {
      padding: "10px",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: "0 12px",
      },
    },
    "& .MuiFormLabel-root.Mui-error": {
      color: brandTheme.errorColor,
    },
    "& .MuiInputLabel-outlined": {
      top: "-7px",
      color: brandTheme.black,
      "@media (max-width:768px)": {
        fontSize: "13px",
      },
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: brandTheme.black,
      top: "0px",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
      "& :hover": {
        borderColor: brandTheme.black,
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
    },
  },
  interestRateError: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.red,
    },
    "& .MuiInputLabel-outlined": {
      color: brandTheme.red,
    },
  },
  addButton: {
    position: "absolute",
    bottom: "33px",
    right: "-30px",
  },
  deleteButton: {
    position: "absolute",
    bottom: "33px",
    right: "-65px",
  },
  minAmountContainer: {
    position: "relative",
  },
  textInput: {
    marginBottom: "2%",
  },
});
const BASE_FORECLOSURE_CHARGES = [
  {
    reason: "Own Fund",
    chargeType: "FLAT",
    amount: 0,
  },
  {
    reason: "BT",
    chargeType: "FLAT",
    amount: 0,
  },
  {
    reason: "Top Up",
    chargeType: "FLAT",
    amount: 0,
  },
];
const useStyles = makeStyles(style);
const SchemeCreate = ({ props, classes }) => {
  const params = useParams();
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();
  const textfieldClass = useStyles();
  const [userId, setUserId] = useState("");
  const [channel, setChannel] = useState("");
  const [channelState, setChannelState] = useState(false);
  const [schemeChannelList, setSchemeChannelList] = useState([]);
  const [codeData, setCode] = useState("");
  const code = codeData?.replace(/[^a-z0-9_]/gi, "");
  const [codeState, setCodeState] = useState(false);
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);
  const [graceday, setGraceDay] = useState("");
  const [gracedayState, setGracedayState] = useState(false);
  const [maxLoanAmount, setMaxLoanAmount] = useState("");
  const [maxLoanAmountState, setMaxLoanAmountState] = useState(false);
  const [minLoanAmount, setMinLoanAmount] = useState("");
  const [minLoanAmountState, setMinLoanAmountState] = useState(false);
  const [ltv, setLtv] = useState("");
  const [ltvState, setLtvState] = useState(false);
  const [interestRate, setInterestRate] = useState({ 1: "" });
  const [interestRateCount, setInterestRateCount] = useState(0);
  const [isActive, setIsActive] = useState("");
  const [interestRateError, setInterestRateError] = useState(false);
  const [foreClosureCharges, setForeClosureCharges] = useState(
    BASE_FORECLOSURE_CHARGES
  );
  const viewPage = window.location.href.includes("createview");
  const [crossSell, setCrossSell] = useState(false);
  const [crossSellPercentage, setCrossSellPercentage] = useState("");
  const [crossSellPercentageState, setCrossSellPercentageState] =
    useState(false);
  const [showModal, setShowModal] = useState(false);
  const [tenureType, setTenureType]=useState("");
  const [tenureDuration, setTenureDuration]=useState("")
  const [frequencyList] = useState([
    { code: "Monthly", name: "Monthly" },
    { code: "Quarterly", name: "Quarterly" },
    { code: "Half_yearly", name: "Half_yearly" },
    { code: "Yearly", name: "Yearly" },
  ]);
  const [processingFeeList] = useState([
    { code: "FLAT", name: "Flat" },
    { code: "PERCENTAGE", name: "Percentage" },
  ]);
  const outletData = useOutletContext();
  const partnerColendingEnabled = parseAndSetFlag(
    outletData?.enablePartnerColendingInScheme
  );
  const showTenureType = parseAndSetFlag(outletData?.showTenureTypeInScheme)
  const crossSellEnabled = parseAndSetFlag(outletData?.enabledCrossSellFlag);
  const enableMinAndAnnualInterestRate = parseAndSetFlag(outletData.enableMinLtvAndInterestRate)
  const enableIsBulletFlag = parseAndSetFlag(outletData.isBulletEnable)
  const enableInsuranceFlag = parseAndSetFlag(
    outletData?.enableInsuranceFlowFlag
  );
  const branchCodeSpecifiedSchemeFlag = parseAndSetFlag(
    outletData?.branchCodeSpecifiedSchemeFlag
  );
  const enabledMinMAxPercentageFieldsCharges = parseAndSetFlag(
    outletData?.enabledMinMAxPercentageFieldsCharges
  );
  const enabledColendingFlag = parseAndSetFlag(
    outletData?.enabledColendingFlag
  );
  const enabledCompoundInterestScheme = parseAndSetFlag(
    outletData?.enabledCompoundInterestScheme
  );
  const interestCalculationTypeList =
    typeof outletData?.interestCalculationTypeFlag === "string"
      ? JSON.parse(outletData?.interestCalculationTypeFlag)
      : outletData?.interestCalculationTypeFlag;
  const daysMethodString = outletData?.daysMethodFlag;
  const daysMethodArray = daysMethodString
    ?.replace(/\[|\]/g, "")
    ?.replace(/'/g, "")
    ?.split(",");
  const [productType, setProductType] = useState("");
  const [productTypeState, setProductTypeState] = useState(false);
  const [interestCalculationType, setInterestCalculationType] = useState(
    interestCalculationTypeList?.[0]?.code
  );
  const [interestCalculationTypeState, setInterestCalculationTypeState] =
    useState(false);
  const [colendingPartnerEnable, setColendingPartnerEnable] = useState(false);
  const [daysMethod, setDaysMethod] = useState(daysMethodArray?.[0]);
  const [daysMethodState, setDaysMethodState] = useState(false);
  const [rateMax, setRateMax] = useState("");
  const [rateMaxState, setRateMaxState] = useState(false);
  const [tenure, setTenure] = useState("");
  const [tenureState, setTenureState] = useState(false);
  const [frequency, setFrequency] = useState("");
  const [frequencyState, setFrequencyState] = useState(false);
  const [interestmissNotificationDays, setInterestmissNotificationDays] =
    useState("");
  const [
    interestmissNotificationDaysState,
    setInterestmissNotificationDaysState,
  ] = useState(false);
  const [processingFee, setProcessingFee] = useState("");
  const [processingFeeState, setProcessingFeeState] = useState(false);
  const [minimumProcessingFee, setMinimumProcessingFee] = useState("");
  const [minimumProcessingFeeState, setMinimumProcessingFeeState] =
    useState(false);
  const [prepaymentChargeType, setPrePaymentChargeType] = useState("");
  const [prePaymentChargeTypeState, setPrePaymentChargeTypeState] =
    useState(false);
  const [prepaymentCharge, setPrePaymentCharge] = useState("");
  const [prepaymentChargeState, setPrepaymentChargeState] = useState(false);

  const [processingType, setProcessingType] = useState("");
  const [processingTypeState, setProcessingTypeState] = useState(false);
  const [interestdueNotificationDays, setInterestdueNotificationDays] =
    useState("");
  const [postMaturityInterestRate, setPostMaturityInterestRate] = useState("");
  const [postMaturityInterestRateState, setPostMaturityInterestRateState] =
    useState(false);
  const [compoundInterest, setCompoundInterest] = useState("");
  const [
    interestdueNotificationDaysState,
    setInterestdueNotificationDaysState,
  ] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");

  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [chargeNameState, setChargeNameState] = useState(false);
  const [chargeNature, setChargeNature] = useState("");
  const [chargeNatureState, setChargeNatureState] = useState(false);
  const [chargeTypeState, setChargeTypeState] = useState(false);
  const [valueSetState, setValueSetState] = useState(false);
  const [minAmountState, setMinAmountState] = useState(false);
  const [maxAmountState, setMaxAmountState] = useState(false);
  const [minPercentageState, setMinPercentageState] = useState(false);
  const [maxPercentageState, setMaxPercentageState] = useState(false);
  const [criteriaTypeState, setCriteriaTypeState] = useState(false);
  const [criteriaAmountState, setCriteriaAmountState] = useState(false);
  const [schemeChargeLength, setSchemeChargeLength] = useState("");
  const [lastIndex, setLastIndex] = useState(-1);
  const [id, setId] = useState("");
  const [groupDetails, setGroupDetails] = useState([]);
  const [chargesApiList, setChargesApiList] = useState([]);
  const [insuranceApplicable, setInsuranceApplicable] = useState(false);
  const [coLending, setCoLending] = useState(false);
  const [selectedBranchCode, setSelectedBranchCode] = useState([]);
  const [branchCodeList, setBranchCodeList] = useState([]);
  const [expendedBranches, setExpandedBranches] = useState(false);
  const [partnerLendingDetails, setPartnerLendingDetails] = useState([]);
  const [partnerCode, setPartnerCode] = useState("");
  const [partnerDealCode, setPartnerDealCode] = useState("");
  const [partnerDealCodeStateError, setPartnerDealCodeStateError]=useState(false)
  const [maxLtvValue, setMaxLtvValue]=useState("");
  const [maxLtvPercentageError, setMaxLtvPercentageError]=useState(false)
  const [minAnnualInterestRate, setMinAnnualInterestRate]=useState("");
  const [minAnnualInterestRateError, setMinAnnualInterestRateError]=useState(false)
    useState(false);
  const [partnerCodeStateError, setPartnerCodeStateError] = useState(false);
  const [productTypeList, setProductTypeList] = useState([]);
   const [annualRateFirstValue, setAnnualRateFirstValue]= useState("");
   const [loanSubType, setLoanSubType]=useState([]);
   const [customerType, setCustomerType]=useState("")
   const [isBullet, setIsBullet]=useState(false)
   const [minInterestDays, setMinInterestDays]=useState("")
   const LoanTypeFlagEnabled = parseAndSetFlag(outletData?.enableLoanTypeInScheme);
   const minInterestDaysScheme = parseAndSetFlag(outletData?.minInterestDaysScheme)
  useEffect(() => {
    getSchemeChannelList();
    getAllChargesList();
    if (branchCodeSpecifiedSchemeFlag) {
      getAllBranchDetails();
    }
    if (params.code && !branchCodeSpecifiedSchemeFlag) {
      editScheme();
    }
  }, []);

  useEffect(() => {
    if (partnerColendingEnabled && colendingPartnerEnable && productType) {
      getLendingDetails();
    }
  }, [productType, colendingPartnerEnable]);
  const getLendingDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.LENDING_DETAIL_FIND + productType,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const partnerLendingDetails =
        result?.data?.filter(
          (item) => item?.active && item?.partnerDealShare?.length > 0
        ) || [];

      setPartnerLendingDetails(partnerLendingDetails);
    }
  };
  const partnerDealData = partnerLendingDetails?.filter(
    (item) => item?.partnerCode === partnerCode
  );
  const getAllBranchDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_ALL_BRANCH,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      const structuredData = [
        {
          code: 1,
          name: "All Branches",
          children: result.data || [],
        },
      ];

      setBranchCodeList(structuredData);
      if (params.code) {
        editScheme(result?.data);
      }
    }
  };
  const editScheme = async (branchCodeListData) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ADMIN_LOANSCHEME_FIND + params.code,
      authToken: authToken,
    });
    setCode(result?.data?.code);
    setName(result?.data?.name);
    setChannel(textFormat(result?.data?.schemeChannel));
    setGraceDay(result?.data?.graceDays);
    setMaxLoanAmount(result?.data?.maxLoanAmount);
    setMinLoanAmount(result?.data?.minLoanAmount);
    setTenure(result?.data?.tenureInMonths);
    setTenureDuration(result?.data?.data?.TENURE);
    setTenureType(result?.data?.data?.TENURE_TYPE)
    setLtv(result?.data?.ltvPercentage);
    setFrequency(textFormat(result?.data?.frequency));
    setInterestmissNotificationDays(result?.data?.interestmissNotificationDays);
    setMinimumProcessingFee(result?.data?.minimumProcessingFee);
    setProcessingFee(result?.data?.processingFee);
    setProcessingType(textFormat(result?.data?.processingFeeType));
    setInterestdueNotificationDays(result?.data?.interestdueNotificationDays);
    setInsuranceApplicable(result?.data?.data?.INSURANCE_APPLICABLE);
    setCoLending(result?.data?.data?.CO_LENDING);
    if (result?.data?.loanSchemeInterestRateMap) {
      const values = Object.values(result?.data?.loanSchemeInterestRateMap);
      setInterestRateCount(values.length - 1);
      setInterestRate(result?.data?.loanSchemeInterestRateMap);
    }
    setRateMax(result?.data?.annualInterestRateMax);
    setPrePaymentChargeType(textFormat(result?.data?.prepaymentChargeType));
    setPrePaymentCharge(result?.data?.prepaymentCharge);
    // setRevaluationChargeType(result?.data?.revaluationChargeType);
    // setRevaluationCharge(result?.data?.revaluationCharge);
    setPostMaturityInterestRate(result?.data?.postMaturityAnnualInterestRate);
    setCompoundInterest(result?.data?.compoundInterestApplicable);
    setForeClosureCharges(result?.data?.foreClosureCharges);
    setId(result?.data?.id);
    let originalArray = addRemovedFields(result?.data?.schemeCharges);
    setGroupDetails(originalArray);
    setLastIndex(result?.data?.schemeCharges?.length - 1);
    setSchemeChargeLength(result?.data?.schemeCharges?.length);
    setIsActive(result?.data?.status === "ACTIVE" ? true : false);
    setCallInProgress(false);
    setInterestCalculationType(result?.data?.interestCalculationType);
    setProductType(result?.data?.productType);
    setCrossSell(result?.data?.data?.CROSS_SELL);
    setCrossSellPercentage(result?.data?.data?.CROSS_SELL_PERCENTAGE);
    setDaysMethod(result?.data?.daysMethod);
    if (result?.data?.branchCodes?.length > 0) {
      setExpandedBranches(true);
      setSelectedBranchCode(result.data.branchCodes);
    } else {
      setSelectedBranchCode([]);
      setExpandedBranches(false);
    }
    if (result?.data?.data?.coLending?.partnerDealCode || result?.data?.data?.coLending?.partnerCode) {
      setColendingPartnerEnable(result?.data?.data?.coLending?.enabled);
      setPartnerDealCode(result?.data?.data?.coLending?.partnerDealCode);
      setPartnerCode(result?.data?.data?.coLending?.partnerCode);
    }
    setMaxLtvValue(result?.data?.maximumLtvPercentage);
    setMinAnnualInterestRate(result?.data?.minimumAnnualInterestRate);
    setAnnualRateFirstValue( Object.values(result?.data?.loanSchemeInterestRateMap)[0]);
    setIsBullet(result?.data?.data?.IS_BULLET)
    setMinInterestDays(result?.data?.data?.MIN_INTEREST_DAYS)
    const selectedSubTypes = loanTypeList?.filter((option) =>
        result?.data?.applicationSubTypes?.includes(option?.value)
      );
    setLoanSubType(selectedSubTypes);
    setCustomerType(getCustomerType(result?.data?.newCustomer))
  };
  const addRemovedFields = (array) => {
    return array?.map((obj) => {
      obj.disabledName = false;
      obj.disabledChargeNature = false;
      obj.disabledChargeType = false;
      obj.disabledValue = false;
      obj.disabledMinAmt = false;
      obj.disabledMaxAmt = false;
      obj.disabled_MAX_PERCENTAGE = false;
      obj.disabled_MAX_PERCENTAGE = false;
      obj.disabledCriteriaAmt = false;
      obj.chargeDetails = obj?.chargeDetails || [];
      obj?.chargeDetails?.forEach((chargeItem) => {
        chargeItem.chargeNatureError = false;
        chargeItem.valueError = false;
        chargeItem.minAmountError = false;
        chargeItem.maxAmountError = false;
      });
      return obj;
    });
  };
  const getSchemeChannelList = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ADMIN_SCHEME_CHANNEL_ALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setSchemeChannelList(result?.data);
    }
  };
  const getAllChargesList = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ADMIN_FIND_ALL_CHARGES,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const filteredArr = result?.data?.chargeTypes?.filter(
        (item) =>
          item.name !== "ONE_TIME_CHARGE" &&
          item.name !== "DOCUMENTATION" &&
          item.name !== "INSURANCE" &&
          item.name !== "CIBIL" &&
          item.name !== "LATE_PAYMENT_PENALTY"
      );
      setChargesApiList(filteredArr);
      FindProductType(
        apiHandler,
        endpoint,
        authToken,
        setProductTypeList,
        setProductType
      );
    }
  };

  const statusUpdate = async (checked) => {
    const status = checked ? "ACTIVE" : "INACTIVE";
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.ADMIN_LOAN_SCHEME_STATUS_UPDATE,
      method: "POST",
      authToken: authToken,
      data: {
        schemeCode: params.code,
        status: status,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Information", res?.data?.message, true);
      setIsActive(checked);
    }
  };

  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isEmpty = Object.values(interestRate).some((value) => value === "");
  // validation for Edit Function
  const isEditValidated = () => {
    if (isEmpty) {
      setInterestRateError(true);
    } else {
      setInterestRateError(false);
    }
        if(minAnnualInterestRate === "" && enableMinAndAnnualInterestRate){
      setMinAnnualInterestRateError(true)
    }else{
      setMinAnnualInterestRateError(false)
    }
    if (graceday === "") {
      setGracedayState(true);
    } else {
      setGracedayState(false);
    }
    if (ltv === "") {
      setLtvState(true);
    } else {
      setLtvState(false);
    }
    if (maxLoanAmount === "") {
      setMaxLoanAmountState(true);
    } else {
      setMaxLoanAmountState(false);
    }
    if (minLoanAmount === "") {
      setMinLoanAmountState(true);
    } else {
      setMinLoanAmountState(false);
    }
    if (rateMax === "") {
      setRateMaxState(true);
    } else {
      setRateMaxState(false);
    }
    if (colendingPartnerEnable && partnerCode === "") {
      setPartnerCodeStateError(true);
    } else {
      setPartnerCodeStateError(false);
    }
    if (colendingPartnerEnable && partnerDealCode === "") {
      setPartnerDealCodeStateError(true);
    } else {
      setPartnerDealCodeStateError(false);
    }
    const updatedGroupDetails = groupDetails?.map((item) => {
      item.disabledName = item?.name?.toString()?.trim() === "";
      item.disabledChargeNature = item?.chargeNature?.toString()?.trim() === "";
      item.disabledChargeType = item?.chargeType?.toString()?.trim() === "";
      item.disabledValue = item?.value?.toString()?.trim() === "";
      item.disabledMinAmt = item?.minAmt?.toString()?.trim() === "";
      item.disabledMaxAmt = item?.maxAmt?.toString()?.trim() === "";
      if (
        item?.chargeType === "CUSTODY" ||
        item?.chargeType === "PREPAYMENT" ||
        item?.chargeType === "PENAL_CHARGE_LTV"
      ) {
        item.disabledCriteriaAmt = item?.criteriaAmt?.toString()?.trim() === "";
      } else {
        item.disabledCriteriaAmt = false;
      }
      const updatedChargeDetails = item?.chargeDetails?.map((chargeItem) => {
        chargeItem.chargeNatureError =
          chargeItem?.chargeNature?.toString()?.trim() === "";
        chargeItem.valueError = chargeItem?.value?.toString()?.trim() === "";
        chargeItem.minAmountError =
          chargeItem?.minAmt?.toString()?.trim() === "";
        chargeItem.maxAmountError =
          chargeItem?.maxAmt?.toString()?.trim() === "";
        return chargeItem;
      });
      return {
        ...item,
        chargeDetails: updatedChargeDetails,
      };
    });
    setGroupDetails(updatedGroupDetails);
    let hasErrors = false;

    updatedGroupDetails.forEach((item) => {
      if (
        item?.name?.toString()?.trim() === "" ||
        item?.chargeNature?.toString()?.trim() === "" ||
        item?.chargeType?.toString()?.trim() === "" ||
        item?.value?.toString()?.trim() === "" ||
        item?.minAmt?.toString()?.trim() === "" ||
        item?.maxAmt?.toString()?.trim() === ""
      ) {
        hasErrors = true;
        return;
      }

      item?.chargeDetails?.forEach((chargeItem) => {
        if (
          chargeItem?.chargeNature?.toString()?.trim() === "" ||
          chargeItem?.value?.toString()?.trim() === "" ||
          chargeItem?.minAmt?.toString()?.trim() === "" ||
          chargeItem?.maxAmt?.toString()?.trim() === ""
        ) {
          hasErrors = true;
          return;
        }
      });
    });
    if (
      graceday !== "" &&
      ltv !== "" &&
      maxLoanAmount !== "" &&
      minLoanAmount !== "" &&
      rateMax !== "" &&
      ((colendingPartnerEnable && partnerCode && partnerDealCode) || !colendingPartnerEnable) && 
          ((minAnnualInterestRate && enableMinAndAnnualInterestRate) || !enableMinAndAnnualInterestRate) &&
      !isEmpty
    ) {
      return true;
    } else {
      return false;
    }
  };
  const filterData = groupDetails?.filter(
    (i) =>
      (i?.chargeType === "PREPAYMENT" && i?.criteriaType) ||
      i?.chargeType === "CUSTODY" ||
      i?.chargeType === "PENAL_CHARGE_LTV"
  );
  // validation function
  const isValidated = () => {
    if (isEmpty) {
      setInterestRateError(true);
    } else {
      setInterestRateError(false);
    }
    if(minAnnualInterestRate === "" && enableMinAndAnnualInterestRate){
      setMinAnnualInterestRateError(true)
    }else{
      setMinAnnualInterestRateError(false)
    }
    if (name === "") {
      setNameState(true);
    } else {
      setNameState(false);
    }
    if (code === "") {
      setCodeState(true);
    } else {
      setCodeState(false);
    }
    if (channel === "") {
      setChannelState(true);
    } else {
      setChannelState(false);
    }
    if (frequency === "") {
      setFrequencyState(true);
    } else {
      setFrequencyState(false);
    }
    if (graceday === "") {
      setGracedayState(true);
    } else {
      setGracedayState(false);
    }
    if (ltv === "") {
      setLtvState(true);
    } else {
      setLtvState(false);
    }
    if (maxLoanAmount === "") {
      setMaxLoanAmountState(true);
    } else {
      setMaxLoanAmountState(false);
    }
    if (minLoanAmount === "") {
      setMinLoanAmountState(true);
    } else {
      setMinLoanAmountState(false);
    }
    if (tenure === "" && !showTenureType) {
      setTenureState(true);
    } else {
      setTenureState(false);
    }
    if (processingType === "") {
      setProcessingTypeState(true);
    } else {
      setProcessingTypeState(false);
    }
    if (processingFee === "") {
      setProcessingFeeState(true);
    } else {
      setProcessingFeeState(false);
    }
    if (minimumProcessingFee === "") {
      setMinimumProcessingFeeState(true);
    } else {
      setMinimumProcessingFeeState(false);
    }
    if (prepaymentChargeType === "") {
      setPrePaymentChargeTypeState(true);
    } else {
      setPrePaymentChargeTypeState(false);
    }
    if (prepaymentCharge === "") {
      setPrepaymentChargeState(true);
    } else {
      setPrepaymentChargeState(false);
    }
    if (postMaturityInterestRate === "" && !enableMinAndAnnualInterestRate) {
      setPostMaturityInterestRateState(true);
    } else {
      setPostMaturityInterestRateState(false);
    }
    if (colendingPartnerEnable && partnerCode === "") {
      setPartnerCodeStateError(true);
    } else {
      setPartnerCodeStateError(false);
    }
    if (colendingPartnerEnable && partnerDealCode === "") {
      setPartnerDealCodeStateError(true);
    } else {
      setPartnerDealCodeStateError(false);
    }
    if (crossSellEnabled && crossSellPercentage === "" && crossSell) {
      setCrossSellPercentageState(true);
      return false;
    } else {
      setCrossSellPercentageState(false);
    }
    if (rateMax === "") {
      setRateMaxState(true);
    } else {
      setRateMaxState(false);
    }
    if (
      (filterData?.length === 1 && !filterData[0].criteriaAmt) ||
      (filterData?.length === 2 && !filterData[1].criteriaAmt) ||
      (filterData?.length === 3 && !filterData[2].criteriaAmt)
    ) {
      setCriteriaAmountState(true);
    } else {
      setCriteriaAmountState(false);
    }
    if (
      (filterData?.length === 1 && !filterData?.[0]?.criteriaType) ||
      (filterData?.length === 2 && !filterData?.[1]?.criteriaType) ||
      (filterData?.length === 3 && !filterData[2].criteriaType)
    ) {
      setCriteriaTypeState(true);
    } else {
      setCriteriaTypeState(false);
    }
    const updatedGroupDetails = groupDetails.map((item) => {
      item.disabledName = item.name?.toString()?.trim() === "";
      item.disabledChargeNature = item.chargeNature?.toString()?.trim() === "";
      item.disabledChargeType = item.chargeType?.toString()?.trim() === "";
      item.disabledValue = item.value?.toString()?.trim() === "";
      item.disabledMinAmt = item.minAmt?.toString()?.trim() === "";
      item.disabledMaxAmt = item.maxAmt?.toString()?.trim() === "";
      if (
        item?.chargeType === "CUSTODY" ||
        item?.chargeType === "PREPAYMENT" ||
        item?.chargeType === "PENAL_CHARGE_LTV"
      ) {
        item.disabledCriteriaAmt = item.criteriaAmt?.toString()?.trim() === "";
      } else if (item?.chargeType === "PROCESSING_FEE") {
        item.disabledCriteriaBase =
          item?.data?.CRITERIA_BASE?.toString()?.trim() === "";
      } else {
        item.disabledCriteriaAmt = false;
      }
      const updatedChargeDetails = item.chargeDetails.map(
        (chargeItem, index) => {
          chargeItem.chargeNatureError =
            chargeItem?.chargeNature?.toString()?.trim() === "";
          chargeItem.valueError = chargeItem?.value?.toString()?.trim() === "";
          chargeItem.minAmountError =
            chargeItem?.minAmt?.toString()?.trim() === "";
          chargeItem.maxAmountError =
            chargeItem?.maxAmt?.toString()?.trim() === "";

          return chargeItem;
        }
      );
      return {
        ...item,
        chargeDetails: updatedChargeDetails,
      };
    });
    setGroupDetails(updatedGroupDetails);
    let hasErrors = false;

    updatedGroupDetails.forEach((item) => {
      if (
        item?.name?.toString()?.trim() === "" ||
        item?.chargeNature?.toString()?.trim() === "" ||
        item?.chargeType?.toString()?.trim() === "" ||
        item?.value?.toString()?.trim() === "" ||
        item?.minAmt?.toString()?.trim() === "" ||
        item?.maxAmt?.toString()?.trim() === ""
      ) {
        hasErrors = true;
        return;
      }

      item?.chargeDetails?.forEach((chargeItem, index) => {
        if (
          chargeItem?.chargeNature?.toString()?.trim() === "" ||
          chargeItem?.value?.toString()?.trim() === "" ||
          chargeItem?.minAmt?.toString()?.trim() === "" ||
          chargeItem?.maxAmt?.toString()?.trim() === ""
        ) {
          hasErrors = true;
          return;
        }
      });
    });
    if (hasErrors) {
      return false;
    }
    const nameCounts = {};
    let hasDuplicateNames = false;

    updatedGroupDetails?.forEach((item) => {
      const trimmedName = item?.name?.toString()?.trim();
      if (trimmedName) {
        nameCounts[trimmedName] = (nameCounts[trimmedName] || 0) + 1;
        if (nameCounts[trimmedName] > 1) {
          hasDuplicateNames = true;
        }
      }
    });

    if (hasDuplicateNames) {
      toastUpdate("Error", "Duplicate Charge Names are not allowed", true);
      return false;
    }
    if (
      name &&
      code &&
      channel &&
      graceday &&
      ltv &&
      maxLoanAmount &&
      minLoanAmount &&
      rateMax &&
      ((minAnnualInterestRate && enableMinAndAnnualInterestRate) || !enableMinAndAnnualInterestRate) &&
      ((postMaturityInterestRate && !enableMinAndAnnualInterestRate) || enableMinAndAnnualInterestRate) &&
      (showTenureType
      ? tenureType && tenureDuration
      : tenure)  &&
      ((colendingPartnerEnable && partnerCode && partnerDealCode) || !colendingPartnerEnable) && 
      !isEmpty &&
      ((filterData?.length === 1 &&
        filterData?.[0]?.criteriaType &&
        filterData[0].criteriaAmt) ||
        (filterData?.length === 2 &&
          filterData?.[1]?.criteriaType &&
          filterData[1].criteriaAmt) ||
        (filterData?.length === 3 &&
          filterData?.[2]?.criteriaType &&
          filterData[2].criteriaAmt) ||
        !filterData.length)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const removeDisabledAndErrorFields = (array) => {
    return array.map((obj) => {
      let newObj = {};
      Object.keys(obj).forEach((key) => {
        if (!key.startsWith("disabled") && key !== "chargeDetails") {
          newObj[key] = obj[key];
        }
      });

      if (obj.chargeDetails && Array.isArray(obj.chargeDetails)) {
        newObj.chargeDetails = obj.chargeDetails.map((chargeItem) => {
          let newChargeItem = {};
          Object.keys(chargeItem).forEach((chargeKey) => {
            if (!chargeKey.endsWith("Error")) {
              newChargeItem[chargeKey] = chargeItem[chargeKey];
            }
          });
          return newChargeItem;
        });
      }

      return newObj;
    });
  };
  const allBranchList = branchCodeList?.map((data) => data?.code);
const processingFeevPercentageValidation = () => {
  let isValid = true;

  groupDetails.forEach((item, i) => {
    if (
      item?.chargeType === "PROCESSING_FEE" &&
      enabledMinMAxPercentageFieldsCharges &&
      item?.chargeNature === "PERCENTAGE" &&
      Number(item?.value) <= 0
    ) {
      const minPercentage = item?.data?.PROCESSINGFEE_PERCENTAGE?.MIN_PERCENTAGE;
      const maxPercentage = item?.data?.PROCESSINGFEE_PERCENTAGE?.MAX_PERCENTAGE;

      const minVal = minPercentage === "" ? "" : Number(minPercentage);
      const maxVal = maxPercentage === "" ? "" : Number(maxPercentage);

      if (minVal === "" && maxVal >= 0) {
        toastUpdate("Error", `Please Add Min Percentage`, true);
        isValid = false;
      } else if (
        minVal >= 0 &&
        (maxVal === "" || maxVal < minVal)
      ) {
        const errorMsg =
          maxVal < minVal && maxVal > 0
            ? "Max Percentage Should Be Greater Than Min Percentage"
            : "Please Add Max Percentage";

        toastUpdate("Error", `${errorMsg}`, true);
        isValid = false;
      }
    }
  });

  return isValid;
};

  const createUserSubmit = async () => {
    if (isValidated() && processingFeevPercentageValidation()) {
      const schemeChargesArr = removeDisabledAndErrorFields(groupDetails);
      console.log(schemeChargesArr,"fjjfsdjfbk")
      const updatedSchemeChargesArr = schemeChargesArr.map((charge) => {
        let updatedData = {
          CRITERIA_BASE: charge?.data?.CRITERIA_BASE ?? null,
        };
      
        if (
          charge?.chargeType === "PROCESSING_FEE" &&
          enabledMinMAxPercentageFieldsCharges &&
          charge?.chargeNature === "PERCENTAGE" &&
          Number(charge?.value) <= 0
        ) {
          const min = parseFloat(charge?.data?.PROCESSINGFEE_PERCENTAGE?.MIN_PERCENTAGE ?? 0);
          const max = parseFloat(charge?.data?.PROCESSINGFEE_PERCENTAGE?.MAX_PERCENTAGE ?? 0);
        
          updatedData.PROCESSINGFEE_PERCENTAGE = {
            MIN_PERCENTAGE: min || 0,
            MAX_PERCENTAGE: max || 0,
          };
        } else {
          // explicitly remove PROCESSINGFEE_PERCENTAGE if it exists
          const { PROCESSINGFEE_PERCENTAGE, ...rest } = charge?.data ?? {};
          return {
            ...charge,
            data: {
              ...rest,
              ...updatedData,
            },
          };
        }
      
        return {
          ...charge,
          data: {
            ...charge.data,
            ...updatedData,
          },
        };
      });
      const colendignData = {
        partnerCode: partnerCode,
        partnerDealCode: partnerDealCode,
        enabled: colendingPartnerEnable,
      };
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.ADMIN_LOANSCHEME_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          name: name,
          code: code?.toUpperCase(),
          schemeChannel: channel?.toUpperCase(),
          graceDays: graceday,
          minLoanAmount: minLoanAmount,
          maxLoanAmount: maxLoanAmount,
          ltvPercentage: ltv,
          annualInterestRateMax: rateMax,
          tenureInMonths: (showTenureType && tenureType === durationUnits?.MONTH) ? tenureDuration : tenure || 0,
          frequency: frequency?.toUpperCase(),
          interestmissNotificationDays: interestmissNotificationDays?.replace(
            /\s/g,
            ""
          ),
          interestdueNotificationDays: interestdueNotificationDays?.replace(
            /\s/g,
            ""
          ),
          // processingFee: Number(processingFee),
          // processingFeeType: processingType?.toUpperCase(),
          // minimumProcessingFee: minimumProcessingFee,
          // prepaymentChargeType: prepaymentChargeType?.toUpperCase(),
          // prepaymentCharge: prepaymentCharge,
          // revaluationChargeType: revaluationChargeType,
          // revaluationCharge: revaluationCharge,
          loanSchemeInterestRateMap: interestRate,
          compoundInterestApplicable: compoundInterest,
          postMaturityAnnualInterestRate: postMaturityInterestRate || rateMax,
          schemeCharges: updatedSchemeChargesArr,
          interestCalculationType: interestCalculationType,
          productType: productType,
          daysMethod: daysMethod,
          data: {
            CROSS_SELL: crossSell,
            CROSS_SELL_PERCENTAGE: crossSell ? crossSellPercentage : 0,
            CROSS_SELL_TYPE: crossSell ? "Personal Loan" : "",
            CROSS_SELL_PROVIDER: crossSell ? "India Finsec" : "",
            INSURANCE_APPLICABLE: insuranceApplicable
              ? insuranceApplicable
              : false,
            CO_LENDING: coLending ? coLending : false,
            ...(partnerColendingEnabled ? { coLending: colendignData } : {}),
            ...(enableIsBulletFlag && { IS_BULLET: isBullet}),
            ...(showTenureType && {
                TENURE_TYPE: tenureType,
                TENURE: Number(tenureDuration),
            }),
            ...(minInterestDaysScheme ? { MIN_INTEREST_DAYS: Number(minInterestDays) } : {}),
          },
          branchCodes: branchCodeSpecifiedSchemeFlag
            ? selectedBranchCode
            : null,
           ...(enableMinAndAnnualInterestRate && {
              maximumLtvPercentage: maxLtvValue,
              minimumAnnualInterestRate: minAnnualInterestRate,
            }),
          ...(LoanTypeFlagEnabled && {
            applicationSubTypes:loanSubType.map(item => item.value),
            newCustomer: getNewCustomerValue(customerType)

          })
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        toastUpdate("Success", "Created Loan Scheme Successfully", true);
        setRedirectURL(`/coreservice/loanScheme`);
      }
    }
  };
  const editUserSubmit = async () => {
    if (isEditValidated()) {
      toastUpdate("", "", false);
      const colendignData = {
        partnerCode: partnerCode,
        partnerDealCode: partnerDealCode,
        enabled: colendingPartnerEnable,
      };
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.ADMIN_LOANSCHEME_UPDATE,
        method: "POST",
        authToken: authToken,
        data: {
          name: name,
          code: code?.toUpperCase(),
          schemeChannel: channel?.toUpperCase(),
          graceDays: graceday,
          minLoanAmount: minLoanAmount,
          maxLoanAmount: maxLoanAmount,
          ltvPercentage: ltv,
          annualInterestRateMax: rateMax,
          tenureInMonths: (showTenureType && tenureType === durationUnits?.MONTH) ? tenureDuration : tenure,
          frequency: frequency?.toUpperCase(),
          interestmissNotificationDays: interestmissNotificationDays?.replace(
            /\s/g,
            ""
          ),
          interestdueNotificationDays: interestdueNotificationDays?.replace(
            /\s/g,
            ""
          ),
          processingFee: Number(processingFee),
          processingFeeType: processingType?.toUpperCase(),
          minimumProcessingFee: minimumProcessingFee,
          prepaymentChargeType: prepaymentChargeType?.toUpperCase(),
          prepaymentCharge: prepaymentCharge,
          // revaluationChargeType: revaluationChargeType,
          // revaluationCharge: revaluationCharge,
          loanSchemeInterestRateMap: interestRate,
          foreClosureCharges: foreClosureCharges,
          compoundInterestApplicable: compoundInterest,
          postMaturityAnnualInterestRate: postMaturityInterestRate || rateMax,
          interestCalculationType: interestCalculationType,
          productType: productType,
          daysMethod: daysMethod,
          data: {
            CROSS_SELL: crossSell,
            CROSS_SELL_PERCENTAGE: crossSell ? crossSellPercentage : 0,
            CROSS_SELL_TYPE: crossSell ? "Personal Loan" : "",
            CROSS_SELL_PROVIDER: crossSell ? "India Finsec" : "",
            INSURANCE_APPLICABLE: insuranceApplicable
              ? insuranceApplicable
              : false,
            CO_LENDING: coLending ? coLending : false,
             ...(minInterestDaysScheme ? { MIN_INTEREST_DAYS: Number(minInterestDays) } : {}),
            ...(partnerColendingEnabled ? { coLending: colendignData } : {}),
            ...(enableIsBulletFlag && { IS_BULLET: isBullet}),
             ...(showTenureType && {
                TENURE_TYPE: tenureType,
                TENURE: Number(tenureDuration),
            })
          },
          branchCodes: branchCodeSpecifiedSchemeFlag
            ? selectedBranchCode
            : null,
            ...(enableMinAndAnnualInterestRate && {
              maximumLtvPercentage: maxLtvValue,
              minimumAnnualInterestRate: minAnnualInterestRate,
            }),
             ...(LoanTypeFlagEnabled && {
            applicationSubTypes:loanSubType.map(item => item.value),
            newCustomer: getNewCustomerValue(customerType)
          })
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        toastUpdate("Success", "Update Loan Scheme Successfully", true);
        setRedirectURL(`/coreservice/loanScheme`);
      }
    } else {
      toastUpdate(
        "Error",
        "Enter the Provide the Loan Scheme Input field",
        true
      );
    }
  };
  const handlecreateuserSubmit = async (event) => {
    if (params.code) {
      editUserSubmit();
    } else {
      createUserSubmit();
    }
  };
  // cancel button function
  const handlecanceluser = () => {
    navigate(`/coreservice/loanScheme`);
  };
  const updateForeClosureCharges = (index, type, value) => {
    let data = [...foreClosureCharges];
    switch (type) {
      case "REASON":
        data[index].reason = value;
        break;
      case "TYPE":
        data[index].chargeType = value.toUpperCase();
        break;
      case "AMOUNT":
        data[index].amount = value;
        break;
      default:
        return "";
    }
    setForeClosureCharges([...data]);
  };
  const removeLastInterestRate = (interestRateCount) => {
    // Create a copy of the interestRate object
    let tempInterestRate = { ...interestRate };
    // Calculate the number of entries to remove
    const entriesToRemove =
      Object.keys(tempInterestRate).length - interestRateCount;
    // Remove the desired number of entries from the end of the object
    for (let i = 0; i < entriesToRemove; i++) {
      delete tempInterestRate[Object.keys(tempInterestRate).length];
    }
    setInterestRateError(false);
    // Update the state with the modified interestRate object
    setInterestRate(tempInterestRate);
  };
  const title = viewPage ? "View Loan Scheme" : "Loan Scheme";
  //
  const handleChangeGRaceDay = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setGraceDay(e);
    }
  };
  const isKeyEmpty = (key) => {
    return interestRate[key] === "";
  };
  const handleChangeLtv = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setLtv(e);
      setMaxLtvValue(e)
    }
  };
  const handleChangeMinLoan = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setMinLoanAmount(e);
    }
  };
  const handleChangeMaxLoan = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setMaxLoanAmount(e);
    }
  };
  const handleChangePostMaturity = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setPostMaturityInterestRate(e);
    }
  };
  const handleChangeDaysMethod = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setDaysMethod(e);
    }
  };
  const handlePartnerCode = (e) => {
    setPartnerCode(e);
  };
  const handlePartnerDealCodeChange = (e) => {
    setPartnerDealCode(e);
  };
  const handleCrossSell = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setCrossSellPercentage(e);
    }
  };
  const handelInterestRate = (event, index) => {
    setInterestRate({
      ...interestRate,
      [index + 1]: event.target.value,
    });
    if(index === 0 && enableMinAndAnnualInterestRate){
      setAnnualRateFirstValue(event?.target?.value)
    }
  };
  const handleOnBLurDays = (event, index) => {
    const newValue = parseFloat(event.target.value);
    const prevValue = parseFloat(interestRate[index]);

    if (!isNaN(prevValue) && newValue < prevValue) {
      toastUpdate(
        "Error",
        `The entered value cannot be smaller than the ${prevValue} value.`,
        true
      );
      setInterestRate({
        ...interestRate,
        [index + 1]: "",
      });
    }
  };
  const handleOnBlurMinLtvPercentage = (e)=>{
      if(Number(e) < Number(ltv)){
        toastUpdate("Error", "Maximum Ltv should be always greather than or equal to Ltv", true)
        setMaxLtvValue(ltv)
      }else{
        setMaxLtvValue(e)
      }
  }
  
  const handleOnBlurMax = (e) => {
    const keys = Object.keys(interestRate).map(Number);
    const lastKey = Math.max(...keys);
    const lastInstallmentRate = interestRate[lastKey];
    if (parseFloat(e) < parseFloat(lastInstallmentRate)) {
      toastUpdate(
        "Error",
        `Max value cannot be less than the ${lastInstallmentRate} last installment rate.`,
        true
      );
      setRateMax(""); // Reset to last valid value
    }
    if (postMaturityInterestRate) {
      if (parseFloat(rateMax) > parseFloat(postMaturityInterestRate)) {
        toastUpdate(
          "Error",
          `Post Maturity Interest Rate cannot be less than the ${rateMax} last installment rate.`,
          true
        );
        setPostMaturityInterestRate("");
      }
    }
  };

  const handleOnBlurPostMaturity = () => {
    const keys = Object.keys(interestRate).map(Number);
    const lastKey = Math.max(...keys);
    const lastInstallmentRate = interestRate[lastKey];
    if (
      parseFloat(postMaturityInterestRate) < parseFloat(lastInstallmentRate)
    ) {
      toastUpdate(
        "Error",
        `Max value cannot be less than the ${lastInstallmentRate} last installment rate.`,
        true
      );
      setPostMaturityInterestRate("");
    }
    if (parseFloat(rateMax) > parseFloat(postMaturityInterestRate)) {
      toastUpdate(
        "Error",
        `Post Maturity Interest Rate cannot be less than the ${rateMax} last installment rate.`,
        true
      );
      setPostMaturityInterestRate("");
    }
  };
  const getSelectedBranchCodeList = () => {
    const options = getCompleteBranchCodeList();
    return options.filter((option) =>
      selectedBranchCode.includes(option.value)
    );
  };
  const getCompleteBranchCodeList = () =>
    branchCodeList.map((item) => ({
      value: item?.code,
      label: `${item?.code} - ${item?.name}`,
    }));
  const handleSelect = (selectedItems) => {
    console.log("Selected:", selectedItems);
    setSelectedBranchCode(selectedItems);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleRateMax = (e) =>{
    setRateMax(e);
    if(enableMinAndAnnualInterestRate){
    setPostMaturityInterestRate(e);
    }
  }
  const handleOnBlurMinAnnualRate = (e)=>{
    if(Number(e) > Number(annualRateFirstValue)){
      toastUpdate("Error", "Minimum annual rate should be always smaller than or equal to 0-30 days interest", true)
      setMinAnnualInterestRate(annualRateFirstValue)
    }else{
      setMinAnnualInterestRate(e)
    }
  }
  const handleNumericInput = (value, setter) => {
    console.log(value,'asjdkhalksdjkhj')
  const regex = /^\d*\.?\d*$/;

  if (value === "" || regex.test(value)) {
    setter(value);
  }
};
const handleTenureType = (e)=>{
  setTenure(0);
  setTenureType(e)
}
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label={title}
            button1={!viewPage && "Save"}
            button2=" Cancel"
            button1click={!viewPage && handlecreateuserSubmit}
            button2click={handlecanceluser}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Name"
              required
              error={nameState}
              id="lp_branch_name"
              value={name || ""}
              setState={setName}
              setError={setNameState}
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Code"
              required
              error={codeState}
              id="lp_branch_code"
              type="code"
              value={code?.toUpperCase() || ""}
              setState={setCode}
              maxLength="8"
              setError={setCodeState}
              disabled={viewPage || params.code}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Channel*"
              error={channelState}
              id="branch_channel"
              value={channel}
              setState={setChannel}
              data={schemeChannelList}
              setError={setChannelState}
              type="channel"
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Interest due frequency*"
              error={frequencyState}
              value={frequency}
              id="branch_interst_due"
              setState={setFrequency}
              data={frequencyList}
              setError={setFrequencyState}
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Interest due Notification Days"
              required
              error={interestdueNotificationDaysState}
              id="lp_Branch_interest_due_notification_days"
              value={interestdueNotificationDays?.replace(/\s/g, "")}
              setState={setInterestdueNotificationDays}
              setError={setInterestdueNotificationDaysState}
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Interest miss Notification Days"
              required
              error={interestmissNotificationDaysState}
              id="lp_branch_interest_missnotification_days"
              value={interestmissNotificationDays?.replace(/\s/g, "")}
              setState={setInterestmissNotificationDays}
              setError={setInterestmissNotificationDaysState}
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Grace Day"
              required
              error={gracedayState}
              id="lp_branch_graceday"
              value={graceday}
              setState={handleChangeGRaceDay}
              setError={setGracedayState}
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Ltv"
              required
              error={ltvState}
              id="lp_branch_ltv"
              value={ltv}
              setState={handleChangeLtv}
              setError={setLtvState}
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Min Loan Amount"
              required
              error={minLoanAmountState}
              id="lp_branch_min_loan_amount"
              value={minLoanAmount}
              setState={handleChangeMinLoan}
              setError={setMinLoanAmountState}
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Max Loan Amount"
              required
              error={maxLoanAmountState}
              id="lp_branch_max_loan_amount"
              value={maxLoanAmount}
              setState={handleChangeMaxLoan}
              setError={setMaxLoanAmountState}
              disabled={viewPage}
            />
          </Grid>
          {!showTenureType &&
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Tenure (in months)"
                required
                error={tenureState}
                id="lp_branch_tenure"
                value={tenure}
                setState={(e) => handleNumericInput(e, setTenure)}
                setError={setTenureState}
                disabled={viewPage}
              />
            </Grid>
          }
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Product Type*"
              error={productTypeState}
              id="product_type"
              value={productType}
              setState={setProductType}
              data={productTypeList}
              setError={setProductTypeState}
              type="newSchemeCharge"
              disabled={viewPage}
            />
          </Grid>
          <Grid xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="InterestCalculation Type*"
              error={interestCalculationTypeState}
              id="interest_calculation_type"
              value={interestCalculationType}
              setState={setInterestCalculationType}
              data={interestCalculationTypeList}
              setError={setInterestCalculationTypeState}
              disabled={viewPage}
              type="newSchemeCharge"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Days Methods*"
              id="days_method"
              error={daysMethodState}
              value={daysMethod}
              setState={handleChangeDaysMethod}
              data={daysMethodArray}
              setError={setDaysMethodState}
              type="packetNumbers"
              disabled={viewPage}
            />
          </Grid>
           {enableMinAndAnnualInterestRate && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Max Ltv Percentage"
              required
              error={maxLtvPercentageError}
              id="min_loan_percetage"
              value={maxLtvValue}
              setState={(e) => handleOnlyNumber(e, setMaxLtvValue)}
              setError={setMaxLtvPercentageError}
              disabled={viewPage}
              setBlur={handleOnBlurMinLtvPercentage}
            />
          </Grid>}
          {branchCodeSpecifiedSchemeFlag && (
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={classes.fieldContaienr}
            >
              <CustomTextSelect
                data={branchCodeList}
                onSelect={handleSelect}
                selectedBranchCodes={selectedBranchCode}
                initiallyExpanded={expendedBranches}
                disabled={viewPage}
              />
            </Grid>
          )}
          {minInterestDaysScheme && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Min Interest Days"
              required
              id="min_interest_days"
              value={minInterestDays}
              setState={(e) => handleOnlyNumber(e, setMinInterestDays)}
              disabled={viewPage}
            />
          </Grid>}
        {LoanTypeFlagEnabled &&  
          <>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr} style={{marginTop:'10px'}}>
              <InputLabel>Loan Sub Types*</InputLabel>
              <MSelect
                closeMenuOnSelect={false}
                components={animatedComponents}
                value={loanSubType}
                isMulti
                isDisabled={viewPage}
                onChange={(e) => {
                  !viewPage && setLoanSubType(e);
                }}
                options={loanTypeList}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                    <CustomSelectNew
                    label="Customer Type*"
                    id="custoemr_type"
                    value={customerType}
                    setState={setCustomerType}
                    data={CustomerTypeList}
                    disabled={viewPage}
                    type="newSchemeCharge"
                  />
                </Grid>
           </>  
        }
          {showTenureType && <>
                <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Tenure Type*"
              id="product_type"
              value={tenureType}
              setState={handleTenureType}
              data={tenureTypeList}
              type="newSchemeCharge"
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Tenure"
              required
              id="tenure_state"
              value={tenureDuration}
              setState={(e) => handleNumericInput(e, setTenureDuration)}
              disabled={viewPage}
            />
          </Grid>
          </>}
          {partnerColendingEnabled && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "black",
                  gap: "20px",
                  fontSize: "16x",
                }}
              >
                {" "}
                <input
                  style={{ marginTop: 2, width: "30px", height: "30px" }}
                  id="select_all"
                  type="checkbox"
                  checked={colendingPartnerEnable}
                  className={classes.checkboxInput}
                  onChange={(e) => setColendingPartnerEnable(e.target.checked)}
                  disabled={viewPage}
                />{" "}
                CoLending partner
              </label>
            </Grid>
          )}
          {colendingPartnerEnable && (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomSelectNew
                  label="Partner Code*"
                  id="partner_code"
                  error={partnerCodeStateError}
                  value={partnerCode}
                  setState={handlePartnerCode}
                  data={partnerLendingDetails}
                  setError={setPartnerCodeStateError}
                  type="partnerCode"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomSelectNew
                  label="Partner Deal Code*"
                  id="partner_deal_code"
                  error={partnerDealCodeStateError}
                  value={partnerDealCode}
                  setState={handlePartnerDealCodeChange}
                  data={partnerDealData}
                  setError={setPartnerDealCodeStateError}
                  type="partnerDealCode"
                />
                <a
                  href
                  onClick={() => setShowModal(!showModal)}
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline",
                    display: "flex",
                  }}
                >
                  Deal Share
                </a>
              </Grid>
            </>
          )}
          {enabledCompoundInterestScheme &&
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "black",
                  gap: "20px",
                  fontSize: "16x",
                }}
              >
                {" "}
                <input
                  style={{ marginTop: 2, width: "30px", height: "30px" }}
                  id="select_all"
                  type="checkbox"
                  checked={compoundInterest}
                  className={classes.checkboxInput}
                  onChange={(e) => setCompoundInterest(e.target.checked)}
                  disabled={viewPage}
                />{" "}
                Compound Interest Applicable
              </label>
            </Grid>
          }
          {enableInsuranceFlag && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "black",
                  gap: "20px",
                  fontSize: "16x",
                }}
              >
                {" "}
                <input
                  style={{ marginTop: 2, width: "30px", height: "30px" }}
                  id="select_all"
                  type="checkbox"
                  checked={insuranceApplicable}
                  className={classes.checkboxInput}
                  onChange={(e) => setInsuranceApplicable(e.target.checked)}
                  disabled={viewPage}
                />{" "}
                Insurance Applicable
              </label>
            </Grid>
          )}
          {enabledColendingFlag && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "black",
                  gap: "20px",
                  fontSize: "16x",
                }}
              >
                {" "}
                <input
                  style={{ marginTop: 2, width: "30px", height: "30px" }}
                  id="select_all"
                  type="checkbox"
                  checked={coLending}
                  className={classes.checkboxInput}
                  onChange={(e) => setCoLending(e.target.checked)}
                  disabled={viewPage}
                />{" "}
                Co lending
              </label>
            </Grid>
          )}
          {crossSellEnabled && (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "black",
                    gap: "20px",
                    fontSize: "16x",
                  }}
                >
                  {" "}
                  <input
                    style={{ marginTop: 2, width: "30px", height: "30px" }}
                    id="selectAll"
                    type="checkbox"
                    checked={crossSell}
                    className={classes.checkboxInput}
                    onChange={(e) => setCrossSell(e.target.checked)}
                  />{" "}
                  Cross Sell
                </label>
              </Grid>
              {crossSell && (
                <>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomeTextField
                      label="Cross Sell Percentage"
                      required
                      value={crossSellPercentage}
                      id="cross_sel_percentage"
                      setState={handleCrossSell}
                      setError={setCrossSellPercentageState}
                      error={crossSellPercentageState}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                 <CustomeTextField
                  label="Cross Sell Type"
                  id="cross_sel_type"
                  value={"Personal Loan"}
                  disabled={true}
                />
              </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                 <CustomeTextField
                  label="Cross Sell Provider"
                  id="cross_sel_provider"
                  value={"India Finsec"}
                  disabled={true}
                />
              </Grid> */}
                </>
              )}
            </>
          )}
          {params.code && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <p style={{ fontWeight: "bold" }}>
                {" "}
                <input
                  id="selectAll"
                  type="checkbox"
                  checked={isActive}
                  className={classes.checkboxInput}
                  onChange={(e) => statusUpdate(e.target.checked)}
                  disabled={viewPage}
                />{" "}
                Active
              </p>
            </Grid>
          )}
            {enableIsBulletFlag && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "black",
                  gap: "20px",
                  fontSize: "16x",
                }}
              >
                {" "}
                <input
                  style={{ marginTop: 2, width: "30px", height: "30px" }}
                  id="select_all"
                  type="checkbox"
                  checked={isBullet}
                  className={classes.checkboxInput}
                  onChange={(e) => setIsBullet(e.target.checked)}
                  disabled={viewPage}
                />{" "}
                Is Bullet
              </label>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={classes.inputFieldContainer}
            style={{ display: "flex" }}
          >
            <h2 className={classes.header}>Annual Interest Rate</h2>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={`${classes.fieldContaienr} ${classes.minAmountContainer}`}
            style={{ position: "relative" }}
          >
            {Array.apply(null, { length: interestRateCount + 1 }).map(
              (e, i) => (
                <div
                  key={i}
                  className={`${textfieldClass.textField} ${
                    textfieldClass.textInput
                  } ${
                    i === interestRateCount && interestRateError
                      ? textfieldClass.interestRateError
                      : ""
                  }`}
                >
                  <TextField
                    label={
                      i === 0
                        ? i * 30 + 0 + "-" + (i * 30 + 30) + " Days*"
                        : i * 30 + 1 + "-" + (i * 30 + 30) + " Days*"
                    }
                    InputLabelProps={{ shrink: true }}
                    id={"lp_rate_" + i}
                    variant="outlined"
                    style={{
                      width: "100%",
                      marginBottom: "20px",
                    }}
                    value={interestRate[i + 1]}
                    onChange={(event) => {
                      if (i === interestRateCount) {
                        setInterestRateError(false);
                      }
                      handelInterestRate(event, i);
                    }}
                    type="number"
                    disabled={viewPage || (!enableMinAndAnnualInterestRate && postMaturityInterestRate) || rateMax}
                    onBlur={(event) => {
                      handleOnBLurDays(event, i);
                    }}
                  />

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    className={`${classes.fieldContaienr} ${
                      i === 0
                        ? textfieldClass.addButton
                        : textfieldClass.deleteButton
                    }`}
                  >
                    {!viewPage && i === interestRateCount && (
                      <>
                        {!isKeyEmpty(i + 1) &&
                          !postMaturityInterestRate &&
                          !rateMax && (
                            <IconButton
                              aria-label="Delete Disbursal"
                              onClick={() => {
                                setInterestRateCount(interestRateCount + 1);
                                setInterestRate({
                                  ...interestRate,
                                  [i + 2]: "",
                                });
                              }}
                              style={{ padding: "0px", marginTop: "2%" }}
                            >
                              <AddIcon
                                style={{
                                  color: "green",
                                  cursor: "pointer",
                                }}
                              />
                            </IconButton>
                          )}
                        {i !== 0 && (
                          <IconButton
                            aria-label="Delete Disbursal"
                            onClick={() => {
                              removeLastInterestRate(interestRateCount);
                              setInterestRateCount(interestRateCount - 1);
                            }}
                            style={{ padding: "0px", marginTop: "2%" }}
                          >
                            <DeleteIcon
                              style={{
                                color: "red",
                                cursor: "pointer",
                              }}
                            />
                          </IconButton>
                        )}
                      </>
                    )}
                  </Grid>
                </div>
              )
            )}
          </Grid>
          {enableMinAndAnnualInterestRate && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Min Annual Interest Rate"
              required
              error={minAnnualInterestRateError}
              id="min_annual_interest_rate"
              value={minAnnualInterestRate}
              setState={setMinAnnualInterestRate}
              setError={setMinAnnualInterestRateError}
              disabled={viewPage}
              setBlur={handleOnBlurMinAnnualRate}
            />
          </Grid>}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Max"
              required
              error={rateMaxState}
              id="lp_branch_max"
              value={rateMax}
              setState={handleRateMax}
              setError={setRateMaxState}
              disabled={viewPage}
              setBlur={handleOnBlurMax}
            />
          </Grid>
          {!enableMinAndAnnualInterestRate && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Post Maturity interest rate"
              required
              error={postMaturityInterestRateState}
              id="lp_branch_post_maturity_interest_rate"
              value={postMaturityInterestRate}
              setState={handleChangePostMaturity}
              setError={setPostMaturityInterestRateState}
              disabled={viewPage}
              setBlur={handleOnBlurPostMaturity}
            />
          </Grid>}

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={classes.inputFieldContainer}
          >
            <SchemeCharge
              classes={classes}
              chargeNameState={chargeNameState}
              setChargeNameState={setChargeNameState}
              chargeNature={chargeNature}
              setChargeNature={setChargeNature}
              chargeNatureState={chargeNatureState}
              setChargeNatureState={setChargeNatureState}
              chargeTypeState={chargeTypeState}
              setChargeTypeState={setChargeTypeState}
              valueSetState={valueSetState}
              setValueSetState={setValueSetState}
              minAmountState={minAmountState}
              setMinAmountState={setMinAmountState}
              maxAmountState={maxAmountState}
              setMaxAmountState={setMaxAmountState}
              minPercentageState={minPercentageState}
              setMinPercentageState={setMinPercentageState}
              maxPercentageState={maxPercentageState}
              setMaxPercentageState={setMaxPercentageState}
              criteriaTypeState={criteriaTypeState}
              setCriteriaTypeState={setCriteriaTypeState}
              criteriaAmountState={criteriaAmountState}
              setCriteriaAmountState={setCriteriaAmountState}
              groupDetails={groupDetails}
              setGroupDetails={setGroupDetails}
              setId={setId}
              id={id}
              editMode={params.code}
              viewPage={viewPage}
              codeData={codeData}
              lastIndex={lastIndex}
              editScheme={editScheme}
              setLastIndex={setLastIndex}
              schemeChargeLength={schemeChargeLength}
              chargesApiList={chargesApiList}
              enabledMinMAxPercentageFieldsCharges={enabledMinMAxPercentageFieldsCharges}
              outletData={outletData}
            />
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {showModal && (
        <DealShareModal
          partnerDealCode={partnerDealCode}
          partnerDealData={partnerDealData}
          showModal={showModal}
          closeModal={handleCloseModal}
        />
      )}
    </div>
  );
};

SchemeCreate.propTypes = {
  classes: PropTypes.object,
};

export default SchemeCreate;
